export const VEHICLE_IDENTIFIER_ECV = 'ecv'
export const VEHICLE_IDENTIFIER_VIN = 'vin'
export const ALL_VEHICLE_IDENTIFIERS = [VEHICLE_IDENTIFIER_ECV, VEHICLE_IDENTIFIER_VIN] as const

export type VehicleIdentifier = (typeof ALL_VEHICLE_IDENTIFIERS)[number]
